// store/data/global.js
import { createSlice } from "@reduxjs/toolkit";

const globalSlice = createSlice({
  name: 'global',
  initialState: {
    currentLanguage: 'JA',
    translations: {
      IndexBannerList: {
        JA: {
          headerONE: 'テクノロジーの力で、',
          headerTWO: '産業の未来をリード',
          subheader: '企業理念：「テクノロジーで未来の生産を創造する」：我々は、テクノロジーが単なるツールではなく、人々の働き方を変え、社会の進化を促す力であると信じています。製造現場の課題に耳を傾け、最適なソリューションを提供することで、豊かな未来社会の実現に貢献します。',
        },
        EN: {
          headerONE: 'Empower Industries,',
          headerTWO: 'Lead the Future with Technology',
          subheader: 'Corporate Philosophy: "Creating the Future Production Model Through Technology": We firmly believe that technology is not merely a tool to enhance efficiency, but the core driving force behind transforming work methods and advancing social progress.'
        }
      },
      IndexHistoryList: {
        JA: {
          caption: '会社の沿革',
          content: '当社ブランドは 2024 年 10 月に東京で設立され、初期は産業用センサーシステム分野に専念して深耕しました。その後、ネットワーク通信及びデータセキュリティ業務に事業を拡大し、2025 年にスマートファクトリー可視化システムを発売しました。近年は AI 産業用自動化及びグリーンデータストレージに焦点を当てています。自社设立以来、常に技術を通じて現場の課題を解決し、「多対一」のサービス体制を提供しています。'
        },
        EN: {
          caption: 'HISTORY',
          content: 'The brand was founded in Tokyo in October 2024. In its early stage, it focused deeply on the field of industrial sensor systems. Subsequently, it gradually expanded its business to network communication and data security, and launched an intelligent factory visualization system in 2025.In recent years, the brand has concentrated on the directions of AI industrial automation and green data storage. It has always taken technology as the core to solve practical on-site problems and provided customers with exclusive one-to-many services.'
        }
      },
      IndexCultureList: {
        JA: [
          {
            header: '企業理念',
            description: '「テクノロジーで未来の生産を創造する」：我々は、テクノロジーが単なるツールではなく、人々の働き方を変え、社会の進化を促す力であると信じています。製造現場の課題に耳を傾け、最適なソリューションを提供することで、豊かな未来社会の実現に貢献します。'
          },
          {
            header: '私たちの企業文化',
            description: 'ゼロベース思考：「当たり前」を疑え。固定概念に縛られず、一から考え、挑戦することを奨励します。フラットな対話：立場に関わらず、誰もが意見を言えるオープンで風通しの良い環境です。ワークライフバランスの尊重：充実した福利厚生とキャリア支援で、社員の活躍と豊かな生活をしっかりサポートします。'
          }
        ],
        EN: [
          {
            header: 'Corporate Philosophy',
            description: '"Creating the Future Production Model Through Technology":We firmly believe that technology is not merely a tool to enhance efficiency, but the core driving force behind transforming work methods and advancing social progress. We consistently listen to the real needs of manufacturing sites, and with customized, high-reliability solutions, we help clients break through development bottlenecks.Together,we move toward a more efficient and sustainable future production landscape, contributing to the high-quality development of the social economy.'
          },
          {
            header: 'Corporate Culture',
            description: 'We advocate "zero-based thinking" and encourage employees to break free from the constraints of fixed perceptions. We promote an "equal communication" mechanism to create an open and inclusive working environment. We value the work-life balance of employees and improve the welfare security and career development system.'
          }
        ]
      },
      IndexTeamList: {
        JA: [
          {
             header: '調達・サプライチェーンチーム',
             lineCover:require('@/assets/home/Team1.webp'),
          },
          {
             header: '営業・ビジネス開拓チーム',
             lineCover:require('@/assets/home/Team2.webp'),
          },
          {
             header: 'マーケティングチーム',
             lineCover:require('@/assets/home/Team3.webp'),
          }, 
          {
             header: '技術・プロダクトマネジメントチーム',
             lineCover:require('@/assets/home/Team4.webp'),
          },
          {
             header: 'カスタマーサクセス・アフターセールスサービスチーム',
             lineCover:require('@/assets/home/Team5.webp'),
          }, 
          {
             header: 'バックオフィスサポートチーム',
             lineCover:require('@/assets/home/Team6.webp'),
          }         
        ],
        EN: [
          {
             header: 'Procurement & Supply Chain Team',
             lineCover:require('@/assets/home/Team1.webp'),
          },
          {
             header: 'Sales & Business Development Team',
             lineCover:require('@/assets/home/Team2.webp'),
          },
          {
             header: 'Marketing Team',
             lineCover:require('@/assets/home/Team3.webp'),
          }, 
          {
             header: 'Technical & Product Management Team',
             lineCover:require('@/assets/home/Team4.webp'),
          },
          {
             header: 'Customer Success & After-Sales Service Team',
             lineCover:require('@/assets/home/Team5.webp'),
          }, 
          {
             header: 'Back-Office Support Teams',
             lineCover:require('@/assets/home/Team6.webp'),
          }
        ]
      },
      IndexDutyList: {
        JA: [
          {
            header: '当社の役割',
            description:'当社は「技術で社会課題を解決する」を使命とし、製造業に生産効率向上及びデータセキュリティ保障のサポートを提供することを通じ、顧客と共に事業発展を推進しています。同時に、当社は環境負荷の低い製品開発を進めるとともに、地域コミュニティとの協力活動に積極的に参加し、持続可能な社会の構築を支援する責任を果たすための具体的な行動を実践していきます。'
          }
        ],
        EN: [
          {
            header: 'Our responsibilities',
            description:'Our company takes "solving social issues with technology" as its mission. By providing manufacturing industries with support for improving production efficiency and ensuring data security, we work hand in hand with customers to drive business development. Meanwhile, we will also advance the R&D of low-environmental-impact products and actively participate in local community cooperation activities, fulfilling our responsibility to contribute to building a sustainable society through practical actions.'
          }
        ]
      },
      SustainableList: {//Sustainable Development
        JA: [
          {
             header: '新エネルギー企業を支援する',
             content:'私たちは新エネルギー産業の技術ニーズに焦点を当て、光発電、風力発電、エネルギー貯蔵シーンに適合するインダストリアルコントロールハードウェア、データセキュリティソリューション及びシステムインテグレーションサービスを提供します。カスタマイズされた可視化ツールの生産を通じて、新エネルギー設備の運用維持効率を最適化し、発電所のデータセキュリティを保障します。技術によって新エネルギー企業のコスト削減と効率向上を実現し、クリーンエネルギーの大規模な応用を加速させます。 ',
             lineCover:require('@/assets/Sustainable/Sustainable1.webp'),
          },
          {
             header: 'カーボンニュートラリティの達成',
             content:'私たちは製品開発からサービス展開までの全プロセスにカーボンニュートラリティ理念を貫き、低消費電力のインダストリアルセンサー、グリーンデータストレージ機器を推出し、ハードウェア運用によるカーボンフットプリントを削減します。同時に、企業向けにカーボンマネジメント可視化システムをカスタマイズし、カーボン排出データのトラッキング、エネルギー消費構造の最適化を支援します。技術とサービスの二輪駆動により、顧客がカーボンニュートラリティ目標に向かって邁進するのをサポートします。',
             lineCover:require('@/assets/Sustainable/Sustainable2.webp'),
          },
      
        ],
        EN: [
          {
             header: 'Empowering New Energy Enterprises',
             content:'We focus on the technology needs of the new energy industry, providing industrial control hardware, data security solutions, and system integration services tailored to photovoltaic, wind power, and energy storage scenarios.  Through the customized production of visualization tools, we optimize the operation and maintenance efficiency of new energy equipment, ensure the data security of power stations, empower new energy enterprises to reduce costs and increase efficiency with technology, and accelerate the large - scale application of clean energy.',
             lineCover:require('@/assets/Sustainable/Sustainable1.webp'),
          },
          {
             header: 'Achievement of Carbon Neutrality',
             content:'We implement the low - carbon concept throughout the entire process from product R & D to service deployment. We launch low - energy - consumption industrial sensors and green data storage devices to reduce the carbon footprint of hardware operation. Meanwhile, we customize carbon management visualization systems for enterprises, helping them track carbon emission data, optimize energy consumption structures, and drive, with the dual wheels of technology and service, customers to move towards the goal of carbon neutrality.',
             lineCover:require('@/assets/Sustainable/Sustainable2.webp'),
          },

        ]
      },
      CaseStudiesList: {//Case Studies
       JA: [
            {             
              header: '自動車製造',
              clientName:'仮称:A社',
              clientPain:' 課題:生産ラインで使用する高精度センサーの調達サイクルが長く、在庫管理コストが課題でした。また、海外メーカーとの直接取引では技術サポートの対応に遅延が発生し、生産計画に影響が出ていました',
              solution:'当社のソリューション:当社は、A社に対し、複数の欧州先端センサーメーカーとの強固なパートナーシップを活かし、「ジャストインタイム」の在庫管理プログラムを提案しました。日本国内に保有一定的安全在庫，并根据A社的生产计划进行週次配送。さらに、現地にいる専任の技術サポートエンジニアが、24時間以内のオンサイト対応を保証しました。',
              solutionImg:require('@/assets/CaseStudies/Cover.gif'),
              CoverImg:require('@/assets/CaseStudies/solution.webp'),     
              Results:[
                {
                  caption:'調達リードタイムを70%短縮（従来の8週間から2.5週間に）',
                  Img:require('@/assets/CaseStudies/Studies1.webp'),
                },
                {
                  caption:'部品在庫コストを約30%削減',
                  Img:require('@/assets/CaseStudies/Studies2.webp'),
                },
                {
                  caption:'生産ラインの停止リスクを大幅に低減し、生産性の向上に貢献しました。',
                  Img:require('@/assets/CaseStudies/Studies3.webp'),
                },
              ]
            },
            {             
              header: 'エンターテインメント',
              clientName:'仮称:B社',
              clientPain:'課題:新作アニメの放送に合わせたプロモーション用の高科技グッズ（スマートIoTグッズ等）の開発を希望していましたが、適切な技術パートナーと調達先が見つからず、時間的な制約もありました。',
              solution:'当社のソリューション:当社は、B社のコンセプトを基に、企画段階から開発・調達・初期生産までのワンストップソリューションを提供しました。インドの信頼できるODMメーカーを紹介し、プロトタイプの迅速な作成とコスト効率の良い生産を実現しました。また、品質管理チームが生産全工程を監視し、高い品質基準をクリアするよう確保しました。',
              solutionImg:require('@/assets/CaseStudies/Cover.gif'),
              CoverImg:require('@/assets/CaseStudies/solution.webp'),  
              Results:[
                {
                  caption:'市場性調査からプロトタイプ完成まで、記録的な3週間で達成',
                  Img:require('@/assets/CaseStudies/Studies1.webp'),
                },
                {
                  caption:'コストを従来予算より20%抑制しつつ、高い品質を実現。',
                  Img:require('@/assets/CaseStudies/Studies2.webp'),
                },
                {
                  caption:'番組の宣伝キャンペーンと完璧に連動し、ファンから大きな反響を得ました。',
                  Img:require('@/assets/CaseStudies/Studies3.webp'),
                },
              ]
            }, 
            {             
              header: 'システムインテグレーション / ITソリューション',
              clientName:'仮称:株式会社システムソリューション',
              clientPain:'課題:大手メーカーからの直接購入では、リードタイムが長く、柔軟なカスタマイズに対応できず、コスト競争力にも課題がありました。特に、スタートアップ企業向けに迅速に構築・納入できるエッジコンピューティングサーバーソリューションの調達先を探していました',
              solution:'当社のソリューション:当社は、お客様の要件を詳細にヒアリングした上で、中国の有力メーカーとの強固なパートナーシップを活かし、オンデマンドでのカスタマイズ仕様に対応しました。さらに、日本国内での事前ベアボーン（準拠品）組み立てと基本動作検証サービスを提供することで、納期を従来の半分以下に短縮しました。また、お客様が自社ソリューションに組み込むための技術ドキュメントとAPI連携サポートも提供しました。',
              solutionImg:require('@/assets/CaseStudies/Cover.gif'),
              CoverImg:require('@/assets/CaseStudies/solution.webp'),  
              Results:[
                {
                  caption:'調達リードタイムを60%短縮（12週間から5週間に）。',
                  Img:require('@/assets/CaseStudies/Studies1.webp'),
                },
                {
                  caption:'顧客固有の仕様（特定のNICやGPUカードの搭載）に対応可能となり、お客様の競争力向上に貢献。',
                  Img:require('@/assets/CaseStudies/Studies2.webp'),
                },
                {
                  caption:'日本国内での検証により、現地での互換性問題を事前に排除し、顧客先でのスムーズな導入を実現。',
                  Img:require('@/assets/CaseStudies/Studies3.webp'),
                },
                {
                  caption:'総合コストを25%削減し、お客様の利益率向上に寄与。',
                  Img:require('@/assets/CaseStudies/Studies4.webp'),
                },
              ]
            },                       
        ],
        EN: [
            {             
              header: 'Auto Manufacturing',
              clientName:'A Major Automotive Parts Manufacturer',
              clientPain:'Company A faced long procurement cycles for high-precision sensors used on its production lines, leading to high inventory management costs. Furthermore, direct transactions with overseas manufacturers often resulted in delayed technical support, impacting production schedules.',
              solution:'Leveraging our strong partnerships with several leading European sensor manufacturers, we proposed a Just-in-Time (JIT) inventory management program for Company A. We maintained a safety stock in our Japanese warehouse and performed weekly deliveries based on Company A’s production schedule. Additionally, our dedicated, locally-based technical support engineer guaranteed on-site response within 24 hours.',
              solutionImg:require('@/assets/CaseStudies/Cover.gif'),
              CoverImg:require('@/assets/CaseStudies/solution.webp'),  
              Results:[
                {
                  caption:'Procurement lead time shortened by 70% (from 8 weeks to 2.5 weeks)',
                  Img:require('@/assets/CaseStudies/Studies1.webp'),
                },
                {
                  caption:'Parts inventory costs reduced by approximately 30%.',
                  Img:require('@/assets/CaseStudies/Studies2.webp'),
                },
                {
                  caption:'Significantly decreased the risk of production line stoppages, contributing to enhanced productivity.',
                  Img:require('@/assets/CaseStudies/Studies3.webp'),
                },
              ]
            },
            {             
              header: 'Global Entertainment Industry',
              clientName:' A Popular Anime IP Derivative Products Developer',
              clientPain:'Company B wanted to develop high-tech promotional goods (e.g., smart IoT gadgets) to coincide with the broadcast of a new anime series. However, they struggled to find suitable technology partners and suppliers within their tight timeframe.',
              solution:'Based on Company B’s concept, we provided a one-stop solution from planning and development to sourcing and initial production. We introduced them to a reliable ODM manufacturer in China, enabling rapid prototyping and cost-effective production. Our quality control team monitored the entire production process to ensure it met high-quality standards.',
              solutionImg:require('@/assets/CaseStudies/Cover.gif'),
              CoverImg:require('@/assets/CaseStudies/solution.webp'),  
              Results:[
                {
                  caption:'Achieved in a record 3 weeks from market research to prototype completion.',
                  Img:require('@/assets/CaseStudies/Studies1.webp'),
                },
                {
                  caption:'Reduced costs by 20% against the original budget while achieving high quality.',
                  Img:require('@/assets/CaseStudies/Studies2.webp'),
                },
                {
                  caption:'Perfectly synchronized with the show’s promotional campaign, generating significant positive feedback from fans.',
                  Img:require('@/assets/CaseStudies/Studies3.webp'),
                },
              ]
            },
            {             
              header: 'System Integration/IT Solutions',
              clientName:'A Mid-Sized System Integrator',
              clientPain:'Direct purchasing from major manufacturers involved long lead times, lacked flexibility for customization, and presented cost-competitiveness challenges. They were specifically looking for a procurement source for edge computing server solutions that could be rapidly built and delivered to their startup clients.',
              solution:'After detailed requirements gathering, we leveraged our strong partnership with a leading Chinese manufacturer to provide on-demand custom specifications. Furthermore, we offered pre-assembly of barebone units and basic operational validation services within Japan, slashing the delivery time by more than half. We also provided technical documentation and API integration support for the client’s own solution stack.',
              solutionImg:require('@/assets/CaseStudies/Cover.gif'),
              CoverImg:require('@/assets/CaseStudies/solution.webp'),  
              Results:[
                {
                  caption:'Procurement lead time shortened by 60% (from 12 weeks to 5 weeks).',
                  Img:require('@/assets/CaseStudies/Studies1.webp'),
                },
                {
                  caption:'Gained the ability to meet specific customer requirements (e.g., installing particular NICs or GPUs), enhancing their competitive edge.',
                  Img:require('@/assets/CaseStudies/Studies2.webp'),
                },
                {
                  caption:'In-country validation preemptively eliminated local compatibility issues, ensuring smooth deployment at customer sites.',
                  Img:require('@/assets/CaseStudies/Studies3.webp'),
                },
                {
                  caption:'Reduced total costs by 25%, contributing to improved profit margins for the client.',
                  Img:require('@/assets/CaseStudies/Studies4.webp'),
                },
              ]
            },            
 
        ]
      },
      CaseTestimonials:{
        JA:[
          {
            name:'評価：システムインテグレーター技術部長より',
            content:'“玄同インターナショナルは、単なるハードウェアの販売店ではなく、私たちのビジネスを理解した上で、技術面でも柔軟にサポートしてくれる真のパートナーです。国内での検証作業は、私たちのエンジニアの負荷を大幅に軽減し、プロジェクトのリスクを低減する上で極めて価値が高いサービスでした。コスト面でも競争力があり、今後も継続的に依頼したいです。”--株式会社システムソリューション 技術部長 井上様',
            Img:require('@/assets/CaseStudies/Testimonials1.webp'),
            keyword:[
              '技術サポート',
              'リスク低減',
              '真のパートナー',
              '国内検証'
            ]
          },
          {
            name:'評価：顧客の IT 部門責任者より',
            content:'“自社でデータセンターを拡張するにあたり、多数のラックサーバーを調達する必要がありました。玄同国際さんには、メーカー直接では難しい細かい仕様調整と、アフターサポートの確約を得ることができました。特に、万が一の際の現地スポット対応の速さには助けられています。”--某Webサービス企業 インフラストラクチャ部 マネージャー 小林様',
            Img:require('@/assets/CaseStudies/Testimonials2.webp'),
            keyword:[
              '仕様調整',
              'アフターサポート',
              '現地対応',
            ]
          },
        ],
        EN:[
          {
            name:' From Manufacturing',
            content:'Unlike traditional suppliers, GenTong International understood and solved our business challenges as a true partner, not just a sales agent. Their rapid response and deep technical support are indispensable for the stable operation of our production lines."——Mr./Ms. Inoue, Director of Technology Department, System Solution Co., Ltd.',
            Img:require('@/assets/CaseStudies/Testimonials1.webp'),
            keyword:[
              'Rapid Response',
              'Deep Technical Support',
              'Stable Production Operation',
            ]
          },
          {
            name:'From Culture & Retail',
            content:'"They provided the optimal solution amidst challenging technical requirements and a tight schedule. Their global supply chain network and project management capabilities were key to this success. We will definitely commission them for our next project."——Mr./Ms. Kobayashi, Infrastructure Department Manager, A Certain Web Service Company',
            Img:require('@/assets/CaseStudies/Testimonials2.webp'),
            keyword:[
              'Optimal Solution',
              'Challenging Technical Requirements',
              'Tight Schedule',
            ]
          },          
        ],
      },
      BusinessMaterialsList:{
        EN:[
           {
              header: 'Industrial Automation Equipment Materials',     
              Results:[
                {
                  caption:'Omron E5CD/E5ED Series',
                  Img:require('@/assets/Business/Materials-1.webp'),
                },
                {
                  caption:'Tolomatic RSA - HT Heavy - Duty Electric Linear Actuator',
                  Img:require('@/assets/Business/Materials-2.webp'),
                },
                {
                  caption:'AIRTAC Cylinders',
                  Img:require('@/assets/Business/Materials-3.webp'),
                },
              ]             
           },
           {
              header: 'Network Communication Equipment',     
              Results:[
                {
                  caption:'Broadcom Optical Transceiver',
                  Img:require('@/assets/Business/Materials-4.webp'),
                },
                {
                  caption:'Cisco Catalyst 4900 Series',
                  Img:require('@/assets/Business/Materials-5.webp'),
                },
              ]             
           },
           {
              header: 'Server',     
              Results:[
                {
                  caption:'Computing Server',
                  Img:require('@/assets/Business/Materials-6.webp'),
                },
                {
                  caption:'Proxy Server',
                  Img:require('@/assets/Business/Materials-7.webp'),
                },
              ]             
           },          
           
        ],
        JA:[
            {             
              header: '産業用自動化機器材料',     
              Results:[
                {
                  caption:'オムロン E5CD/E5ED シリーズ',
                  Img:require('@/assets/Business/Materials-1.webp'),
                },
                {
                  caption:'トロマティック RSA - HT じゅう Duty でんどうリニアアクチュエータ',
                  Img:require('@/assets/Business/Materials-2.webp'),
                },
                {
                  caption:'アタックシリンダー',
                  Img:require('@/assets/Business/Materials-3.webp'),
                },
              ]
            },
           {
              header: 'ネットワーク通信機器',     
              Results:[
                {
                  caption:'Broadcom こうたんき',
                  Img:require('@/assets/Business/Materials-4.webp'),
                },
                {
                  caption:'Cisco Catalyst 4900 ジリ-ズ',
                  Img:require('@/assets/Business/Materials-5.webp'),
                },
              ]             
           },
           {
              header: 'サーバー',     
              Results:[
                {
                  caption:'計算サーバー',
                  Img:require('@/assets/Business/Materials-6.webp'),
                },
                {
                  caption:'プロキシサーバー',
                  Img:require('@/assets/Business/Materials-7.webp'),
                },
              ]             
           },            
        ],
      },
      BusinessDataSecurity:{
        EN:[
          { 
             header: 'Data Encryption Products',  
             data:[
               {
                 type:'DocArmor',
                 Img:require('@/assets/Business/Encryption1.webp'),
               },
               {
                 type:'Symantec Data Loss Prevention',
                 Img:require('@/assets/Business/Encryption2.webp'),
               },
             ]
          },
          { 
             header: 'Data Desensitization Products',  
             data:[
               {
                 type:'PowerData Data Desensitization Platform',
                 Img:require('@/assets/Business/Desensitization1.webp'),
               },
               {
                 type:'DPtech Data Static Desensitization System',
                 Img:require('@/assets/Business/Desensitization2.webp'),
               },
             ]
          },
        ],
        JA:[
          {
             header: 'データ暗号化製品',  
             data:[
               {
                 type:'DocArmor',
                 Img:require('@/assets/Business/Encryption1.webp'),
               },
               {
                 type:'Symantec Data Loss Prevention',
                 Img:require('@/assets/Business/Encryption2.webp'),
               },
             ]
          },
          {
             header: 'データ脱敏製品',  
             data:[
               {
                 type:'パオワンダ データ だめん プラットフォーム',
                 Img:require('@/assets/Business/Desensitization1.webp'),
               },
               {
                 type:'ディーピュー テクノロジー データ せいてき だめん システム',
                 Img:require('@/assets/Business/Desensitization2.webp'),
               },
             ]
          },
        ],
      },
      BusinessCustomized:{
        EN:[
          { 
             header: 'Customized Software Design UI', 
             Img:require('@/assets/Business/Customized1.webp'), 
             content:'Tailored to industry characteristics and user operation habits, we create a concise and intuitive UI that is compatible with multiple terminals. It presents functions with clear visual hierarchies, balancing aesthetics and usability to enhance operation efficiency and user experience.',
             link:'/contact',
          },
          { 
             header: 'Customized Visual Production Services', 
             Img:require('@/assets/Business/Customized2.webp'), 
             content:'Based on customers’ production scenarios and data needs, we custom-develop industrial visualization systems. These systems integrate data such as equipment, production capacity, and quality, and present the entire production process through dynamic charts and 3D modeling. They support real-time monitoring, abnormal warning, and data tracing, helping enterprises intuitively grasp production status, quickly optimize decision-making, and improve production efficiency and management precision.',
             link:'/contact',
          },
           { 
             header: 'Dedicated Hybrid Case Resolution', 
             Img:require('@/assets/Business/Customized3.webp'), 
             content:'',
             link:'/contact',
          },  
        ],
        JA:[
          { 
             header: 'カスタマイズドソフトウェアデザイン UI ', 
             Img:require('@/assets/Business/Customized1.webp'), 
             content:'業界の特性とユーザーの操作習慣に合わせて、シンプルで分かりやすい UI をカスタマイズし、多端末に対応します。明確な視覚的階層で機能を提示し、美観と使いやすさを両立させ、操作効率とユーザーエクスペリエンスを向上させます。',
             link:'/contact',
          },
          { 
             header: 'カスタマイズされた可視化生産サービス', 
             Img:require('@/assets/Business/Customized2.webp'), 
             content:'顧客の生産シナリオとデータニーズに基づき、産業用可視化システムをカスタマイズして開発し、設備、生産能力、品質などのデータを統合し、動的なチャート、3 次元モデリングで生産の全プロセスを提示します。リアルタイム監視、異常予警、データトレースバックに対応し、企業が生産状況を直感的に把握し、迅速に意思決定を最適化し、生産効率と管理精度を向上させるのをサポートします。',
             link:'/contact',
          },
           { 
             header: '専用ハイブリッドケースソリューション', 
             Img:require('@/assets/Business/Customized3.webp'), 
             content:'',
             link:'/contact',
          },         
        ],
      },
      FutureCooperation:{
        EN:[
          { 
             title: 'International Cooperation', 
             Img:require('@/assets/Future/Cooperation1.webp'), 
             content:'Upholding the concept of open cooperation for mutual benefit, we actively engage in the global wave of technological collaboration. We join hands with top - tier technology enterprises and research institutions in Europe, America, Asia, etc., to make joint breakthroughs in core fields such as industrial automation and data security. We share cutting - edge technologies and innovative achievements, participate in formulating international standards, and leverage the advantageous resources of all parties. This accelerates the R & D and application of new technologies, enhances global influence, and drives technological innovation in the industry.',
          },
          { 
             title: 'Empowering Local Enterprises', 
             Img:require('@/assets/Future/Cooperation2.webp'), 
             content:'By deeply understanding the needs of local enterprises, we provide solid support for the intelligent transformation of traditional manufacturing and the digital development of emerging enterprises with our rich product portfolio and customized services. We optimize production processes with efficient industrial control hardware and safeguard enterprises’ information assets through advanced data security solutions. This helps local enterprises improve efficiency and strengthen competitiveness in global competition, promotes the upgrading of Japan’s industrial structure, and consolidates the foundation of the local industry.',
          },
          { 
             title: 'Empowering Local Enterprises', 
             Img:require('@/assets/Future/Cooperation3.webp'), 
             content:'We continuously increase R & D investment to break through technological bottlenecks and benchmark against leading industry enterprises in key technical indicators. By optimizing service quality and expanding business scope, we enhance the international reputation of our brand. In cutting - edge fields like 5G industrial applications and the integration of AI and industry, we resonate with industry giants, showcase our strength on the global stage, jointly lead new directions for industry development, and build a new mutually beneficial global technology industry landscape.',
          }, 
        ],
        JA:[
          { 
             title: '国際連携', 
             Img:require('@/assets/Future/Cooperation1.webp'), 
             content:'オープンでウイン・ウインの理念を持ち、積極的にグローバルなテクノロジー協力の潮流に参画します。欧米、アジアなどのトップテクノロジー企業や科研機関と連携し、産業用自動化、データセキュリティなどのコア分野で共同で難関を突破します。先端技術と革新的成果を共有し、国際規格の策定に参画し、各方面の優位なリソースを活用して、新技術の研究開発と応用の着地を加速させ、グローバルな影響力を高め、業界の技術革新を推進します。',
          },
          { 
             title: '国内企業支援', 
             Img:require('@/assets/Future/Cooperation2.webp'), 
             content:'国内企業のニーズを深く洞察し、豊富な製品体系とカスタマイズサービスを通じて、伝統的製造業のスマート化変革、新興企業のデジタル化発展にしっかりとしたサポートを提供します。効率的な産業用コントロールハードウェアで生産プロセスを最適化し、先進的なデータセキュリティソリューションで企業の情報資産を保障し、国内企業がグローバル競争において効率を高め、競争力を強化するのを支援し、日本の産業構造アップグレードを推進し、国内の産業基盤を強固にします。',
          },
          { 
             title: '業界リーダーと並走', 
             Img:require('@/assets/Future/Cooperation3.webp'), 
             content:'引き続き研究開発への投入を強化し、全力で技術のボトルネックを突破し、重要な技術指標で業界トップ企業に対標します。サービス品質の最適化、事業版图の拡大を通じて、ブランドの国際的知名度を高めます。5G 産業応用、人工知能と産業の融合などの先端分野で、業界の大手企業と共鳴し、グローバルなステージで実力を示し、共に業界の発展の新たな方向をリードし、相互に利益を享受するグローバルなテクノロジー産業の新たな構図を構築します。 ',
          },                    
        ],
      },
      NewsList:{
        EN:[
          { 
             title:'Current State of Japan’s Industry', 
             Img:require('@/assets/News/News1.webp'), 
             content:'In Japan, the technology industry is in a period of transformation. The traditional manufacturing industry has a strong foundation. For example, technologies in fields like industrial automation and robotics are mature. However, in the emerging AI field, despite the government ramping up investment and introducing a series of supportive policies, the progress of R & D and application lags behind that of China and the United States. The AI utilization rate among the public and enterprises is low. Meanwhile, population aging has led to a labor shortage, forcing enterprises to seek technological means to improve efficiency, which provides opportunities for the application of innovative technologies.',
          },
          { 
             title:'International Perspective', 
             Img:require('@/assets/News/News2.webp'), 
             content:'From a global view, the global technology competition is fierce, with cloud computing, big data, and the Internet of Things developing vigorously. Japanese technology enterprises, in advantageous fields such as semiconductors and precision manufacturing, face challenges from strong competitors like those in Europe, the United States, and China. In emerging fields, Japan needs to speed up, learn from and absorb advanced international technologies and experiences, enhance its own competitiveness, and integrate into the wave of global technology development.',
          },
        ],
        JA:[
          { 
             title: '日本の業界現状', 
             Img:require('@/assets/News/News1.webp'), 
             content:'国内において、日本のテクノロジー業界は変革期にあります。伝統的な製造業は根強い基盤を持ち、例えば産業用自動化、ロボット分野では技術が成熟しています。しかし、新興の AI 分野においては、政府が投入を強化し、一連の支援政策を打ち出しているにもかかわらず、研究開発と応用の進捗は中米に後れ、一般市民や企業による AI 使用率は低いです。同時に、人口高齢化により労働力が不足し、企業に対して技術手段で効率を向上させることを余儀なくさせており、革新的なテクノロジー応用に向けた契機を提供しています。',
          },
          { 
             title: 'グローバルビジョン', 
             Img:require('@/assets/News/News2.webp'), 
             content:'国際的な視点から見ると、世界的なテクノロジー競争は激しく、クラウドコンピューティング、ビッグデータ、モノのインターネットが盛んに発展しています。日本のテクノロジー企業は、半導体、精密製造などの強み分野において、欧米、中国などの強力なライバルからの挑戦に直面しています。新興分野においては、日本はスピードを上げ、国際的な先進技術や経験を参考に吸収し、自らの競争力を高め、世界のテクノロジー発展の流れに溶け込む必要があります。 ',
          },
        ],
      }
    }
  },
  reducers: {
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    }
  }
});

// 导出actions
export const { setLanguage } = globalSlice.actions;

// 导出选择器函数
export const getCurrentLanguage = (state) => state.global.currentLanguage;
export const getTranslations = (state) => state.global.translations;

export default globalSlice.reducer;